export default __webpack_public_path__ + "static/media/inside.dfb1e511.png";